<template>
  <v-layout class="flex-column">
    <v-layout wrap fill-height>
      
      <headband-pump
        :title="pump.sku.sku"
        :markets="pump.sku.lines"
        :breadcrumb="['Home', 'Pumps', pump.sku.sku]"
        :imageBackground="''"
        :count="pump.count"
        :imagesPreview="pump.sku.thumbnails"
      />

      <v-container class="py-10">
        <v-row v-if="!isLoad && getFiles.length !== 0">

          <!-- <v-list class="pb-5">
            <v-list-item>
              <v-select
                flat
                multiple
                small-chips
                clearable
                v-model="valueLanguages"
                :items="pump.languages"
                :label="$t('theme.filterLanguages')"
                :menu-props="{
                  closeOnClick: true,
                  closeOnContentClick: true,
                  auto: true,
                  overflowY: true
                }"
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">
                    <languages :data="[item.toLowerCase()]" />
                  </span>
                  <span v-if="index === 1">
                    <languages :data="[item.toLowerCase()]" />
                  </span>
                  <span v-if="index === 2">
                    <languages :data="[item.toLowerCase()]" />
                  </span>
                  <span
                    v-if="index === 3"
                    class="grey--text caption"
                  >({{$tc('theme.others', valueLanguages.length - 3)}})</span>
                </template>
                <template v-slot:item="{ item }">
                  <v-list-item-icon class="mt-0 mb-0">
                    <languages :data="[item.toLowerCase()]" />
                  </v-list-item-icon>
                  {{ item }}
                </template>
              </v-select>
            </v-list-item>
          </v-list>
          <v-btn>Filtrer</v-btn> -->

          <v-expansion-panels
            tile
            hover
            accordion
            focusable
          >
            <v-expansion-panel
              v-for="(tab, index) in sortFiles"
              :key="'accordion-' + tab + '-' + index"
              expand
            >
              <v-expansion-panel-header>
                <h2 class="v-row-title display-1 d-flex align-center mb-0">
                  <span class="ml-0">
                    <span class="ml-0">
                      {{ i18nCategory(tab) }}
                    </span>
                    <small class="subtitle-1 font-weight-light">{{ $tc('theme.documentCount', [pump.files[tab].length]) }}</small>
                  </span>
                </h2>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col
                    cols="12" sm="6" md="4" lg="3"
                    class="mb-2"
                    v-for="(file, fileIndex) in pump.files[tab]"
                    :key="fileIndex"
                  >
                    <document :pump="file"></document>
                  </v-col>
                </v-row>
          
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

        </v-row>
        <v-row v-if="!isLoad && getFiles.length === 0">
          <v-col
            cols="12" sm="6"
          >
            <v-alert
              icon="mdi-information-outline"
              prominent
              text
              type="info"
              class="mb-0"
            >
              <span v-html="$t('page.pump.message.noresult', [pump.sku.sku])" />
            </v-alert>
          </v-col>
        </v-row>
      </v-container>

    </v-layout>
    <block-newsletter />
  </v-layout>
</template>
<script>
import Mixins from '@/core/mixins'
export default {
  name: 'Pump',
  mixins: [ Mixins ],
  data() {
    return {
      isLoad: true,
      valueLanguages: [],
      pump: {
        sku: {},
        files: {},
        languages: [],
        attachments: {},
      }
    }
  },

  components: {
    HeadbandPump: () => import(/* webpackChunkName: "HeadbandPump" */ '@/modules/headband/HeadbandPump'),
    BlockNewsletter: () => import(/* webpackChunkName: "BlockNewsletter" */ '@/modules/block/BlockNewsletter'),
    Document: () => import(/* webpackChunkName: "Document" */ '@/components/layout/Document'),
  },

  mounted() {
    this.$ga.page(`/pumps/${this.$route.params.sku}`);
  },

  created () {
    this.handler()
  },
  
  watch:{
    '$route': 'handler'
  },

  computed: {
    getFiles () {
      const files = Object.keys(this.pump.files)
      if (files.length !== 0) {
        return files
      } else {
        return []
      }
    },
    
    sortFiles () {
      const files = this.getFiles
      return files.sort()
    }
  },

  methods: {
    async handler () {
      const sku = this.$route.params.sku
      const langauges = this.$route.query.l ? '?l=' + this.$route.query.l : ''
      const response = await this.request(`/pumps/${sku}${langauges}`)
      this.pump = response
      this.isLoad = false
    }
  }
}
</script>
